export const ORDER_SHIPPING_ADDRESS_FORM = 'ORDER_SHIPPING_ADDRESS_FORM'
